import React from "react";
import { ShowMoreDotsIcon } from "../showMoreDotsIcon/showMoreDotsIcon";
import styles from "./showMoreIcon.css";

interface Props extends React.HTMLProps<HTMLDivElement> {
  text: string;
}
export const ShowMoreIcon = ({ text, ...props }: Props) => {
  return (
    <div {...props} className={styles.container}>
      <ShowMoreDotsIcon />
      <p className={styles.text}>{text}</p>
    </div>
  );
};
